import React, { useContext } from 'react';
import { useDispatch } from 'react-redux';
import { push } from 'connected-react-router';
import { AppContext } from 'src/providers/AppContextProvider';
import { IAppContextState } from 'src/reducers/AppContext';
import ReportName from 'src/models/ReportName';
import IndexReferenceType from 'src/models/IndexReferenceType';
import moment from 'moment';

interface IReportGroupProps {
    // id: number;
    // TODO: Only name used is 'Core'. Check if this prop is needed.
    name: string;
    reports: ReportName[];
    categories: IndexReferenceType[];
}

const ReportGroup = (props: IReportGroupProps) => {
    const dispatch = useDispatch();
    const appContext = useContext<IAppContextState>(AppContext);

    const navReportDetail = (reportId: number) => {
        dispatch(push(`/clients/${appContext.clientNumber}/projects/${appContext.projectNumber}/reports/${reportId}`));
    };

    const displayReports = () => {
        return props.categories.map((category) => {
            let catReports = props.reports.filter(r => r.categoryNumber === category.id);
            if (catReports.length > 0) {
                return (
                    <div key={`Category-${category.id}`} className="report-category">
                        <div>{category.name.toUpperCase()}</div>
                        {catReports.map((report) => {
                            return (
                                <div key={report.id} style={{ display: 'flex' }}>
                                    <div className="report clickable" onClick={() => navReportDetail(report.id)}>
                                        {report.reportNumberDisplay} - {report.title}
                                    </div>
                                    <div>
                                        | {report.description} | Last Updated: {moment(report.updateDate).format('YYYY-MM-DD') as unknown as Date}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                );
            }

            return <div key={`Category-${category.id}`} />;
        });
    };

    return (
        <div className="report-group-card">
            <div className="title">{props.name}</div>
            <div className="report-group-report-list">{displayReports()}</div>
        </div>
    );
};

export default ReportGroup;



// WEBPACK FOOTER //
// ./src/components/project/sections/ReportComponents/ReportGroup.tsx